const FOCUSABLE_SELECTOR = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
const focusOnTheFirstElement = () => {
  const focusable = document.querySelector(FOCUSABLE_SELECTOR);
  focusable?.focus();
};

export { focusOnTheFirstElement };
//# sourceMappingURL=focus-on-the-first-element.js.map
